export const PROTEIN_MIN_VALUE = 10
export const PROTEIN_MAX_VALUE = 15.5
